<template>

<app-input class="scheduletime" :wide="wide" :messages="messages" :locked="locked" :prefix="prefix" :label="label" :stacked="stacked" :no-line="noLine" :notes="notes" :disabled="disabled" :validation="validation">

	<div class="suggesttime-wrapper" :class="{'has-picker': hasPicker, 'has-space': showSpace}">

		<app-input-select v-if="showSpace" v-tooltip="(hasPicker) ? 'Use picker to change space' : false" :locked="hasPicker" v-model="model.space" placeholder="Select space" :options="spaceOptions" />
		<app-input-select v-tooltip="(hasPicker) ? 'Use picker to change day' : false" :locked="hasPicker" v-model="model.day" placeholder="Select day" :options="$con.schedule.days" />
		<app-input-select v-tooltip="(hasPicker) ? 'Use picker to change time' : false" :locked="hasPicker" v-model="model.time" placeholder="Select time" :options="times" />
		<app-input-select v-tooltip="(hasPicker) ? 'Use picker to change duration' : false" :locked="hasPicker" v-model="model.duration" placeholder="Select duration" :options="$con.schedule.durations" />
        <app-button v-if="hasPicker" class="suggesttime-picker" v-on:click="onPickerClick">Pick time</app-button>

	</div>

</app-input>

</template>

<script>

export default {

	props: ['label', 'wide', 'room', 'isCustom', 'messages', 'hasPicker', 'showSpace', 'spaces', 'password', 'locked', 'loading', 'prefix', 'validation', 'numeric', 'autogrow', 'disabled', 'value', 'noLine', 'stacked', 'placeholder', 'notes'],

    data: function() {
    
        return {
            model: {
                space: '',
                day: 0,
                time: 0,
                duration: 0
            },
            is: {
                picking: false
            }        
        }
    
    },

    created: function() {

        if (this.value) {

            this.model.space = this.value.space || ''
            this.model.day = this.value.day
            this.model.time = this.value.time
            this.model.duration = this.value.duration

        }

    },

    watch: {
    
        model: {
        
            deep: true,

            handler: function(n) {

                if (this.isCustom) {

                    this.$emit('space', n.space)
                    this.$emit('day', n.day)
                    this.$emit('time', n.time)
                    this.$emit('duration', n.duration)
                
                } else {

                    if (n.day && n.time && n.duration) {
                    
                        this.$emit('input', n)

                    } else {
                    
                        this.$emit('input', false)

                    }
                    
                }

            }
        
        }
    
    },

    computed: {

        spaceOptions: function() {
        
            var spaces = {}

            this.$_.each(this.spaces, function(item) {
            
                spaces[item.id] = item.name
            
            })

            return spaces

        },
    
        times: function() {

            if(!this.room) return this.$con.schedule.times
        
            var times = {}

            this.$_.each(this.$con.schedule.times, function(text, value) {
            
                if(value >= this.room.schedule.start && value <= this.room.schedule.end) times[value] = text
            
            }.bind(this))

            return times
        
        }

    },

    methods: {
    
        onPickerClick: function() {

            this.is.picking = true

            this.$pubsub.$on('picker.confirmed', this.onPickerConfirmed)
            this.$pubsub.$on('picker.closed', this.onPickerClosed)
        
            this.$emit('picker', this.model)
        
        },

        onPickerConfirmed: function(e) {

            this.model.space = e.space
            this.model.day = e.day 
            this.model.duration = e.duration 
            this.model.time = e.time 

        },

        onPickerClosed: function() {

            if(this.is.picking) {

                this.$pubsub.$off('picker.confirmed', this.onPickerConfirmed)
                this.$pubsub.$off('picker.closed', this.onPickerClosed)

                this.is.picking = false

            }

        }
    
    }

}

</script>

<style scoped>

.suggesttime-wrapper {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr 1fr;
}

.suggesttime-wrapper.has-picker {
    grid-template-columns: 1fr 1fr 1fr 120px;
}

.suggesttime-wrapper.has-space {
    grid-template-columns: 1fr 1fr 1fr 120px;
}

.suggesttime-wrapper.has-space.has-picker {
    grid-template-columns: 1fr 1fr 1fr 1fr 120px;
}

.is-mobile .suggesttime-wrapper {
    grid-template-columns: 1fr;
}

.suggesttime-picker {
    width: 100%;
    height: 40px;
    border-radius: 10px;
}

.suggesttime-wrapper >>> .input {
    margin-bottom: 0px;
}

</style>
